<template>
  <div class="dowbox">
    <div class="left">
      <img class="logo" src="@/assets/image/icon/logo.png" alt="">
      <p>超多精彩福利都在这里</p>
    </div>
    <sdkdow-btn width="4.4rem" height="1.4rem" text="立即下载" :isbg="false"></sdkdow-btn>
  </div>
</template>

<script>
import sdkdowBtn from './sdkdowBtn.vue';
export default {
  components: { sdkdowBtn },
  name: 'VueNew39DowBox',

  data() {
    return {

    };
  },

  mounted() {

  },

  methods: {

  },
};
</script>

<style lang="scss" scoped>
.dowbox {
  height: 2.4rem;
  background-color: #FBF0D6;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 0.5rem;
  flex-shrink: 0;
  position: sticky;
  top: 0;
  z-index: 1000;
  .left{
    display: flex;
    align-items: center;
    p{
      color: #855200;
      font-size: .6rem;
      margin-left: .15rem;
    }
  }
  .logo {
    width: 6rem;
  }
}
</style>